import { PutOrderGroupRequest } from '@/coreInfrastructureModule/axios/generated/orderGroupManage';
import { IOrderGroup } from '../../coreDomainsModule/entities/IOrderGroup';
import { DateService } from '@/coreDomainsModule/services/dateService';

/**
 * 発注グループ編集のアダプタ
 */
export class UpdateOrderGroupAdapter {
  /**
   * 変換する
   * @param editedOrderGroup - 編集された発注グループ
   */
  public static adapt(editedOrderGroup: IOrderGroup): PutOrderGroupRequest {
    const putOrderGroupRequest: PutOrderGroupRequest = {
      estimatedTimeOfArrival: editedOrderGroup.eta
        ? DateService.formatDateToISOString(DateService.convertUnixTimeToDate(editedOrderGroup.eta / 1000))
        : undefined,
      updateOrderGroupInfo: {
        orderGroupName: editedOrderGroup.orderGroupName,
        invoiceNumber: editedOrderGroup.invoiceNumber || undefined,
        destinationName: editedOrderGroup.destinationName || undefined,
        upperLimitQuantity: editedOrderGroup.upperLimitQuantity,
        memo: editedOrderGroup.memo,
      },
    };
    return putOrderGroupRequest;
  }
}
